enum USER_SUBSCRIPTIONS {
    HTML_REPORT = 'htmlReports',
    SCHEDULED_REPORT = 'scheduledReports',
}

export default USER_SUBSCRIPTIONS;
